/* eslint-disable no-plusplus */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';

import $ from 'jquery';
import { func, arrayOf, shape, bool } from 'prop-types';

import { CheckBox, InputFormField } from '../../../../common';
import { getUpdatedFormDataForAddService } from '../../Common/commonFunctionsForUniqueServices';

export default function StandardServices({
  formData,
  stdServices,
  updatedFormData,
  setFormData,
  setUpdatedFormData,
  showFooter,
  contractAddendumDetails,
  addendumDetails,
  originalData,
}) {
  const selectedStdServices =
    (contractAddendumDetails?.notActive
      ? addendumDetails?.standard_us_services
      : originalData?.standard_us_services) || [];

  const [allSelected, setAllSelected] = useState(
    formData?.standard_us_services?.length === stdServices?.length,
  );

  const removeServicesWithId = (tempServices) => {
    let serviceLength = tempServices?.length || 0;
    while (serviceLength--) {
      for (const item of selectedStdServices) {
        if (
          tempServices[serviceLength] &&
          tempServices[serviceLength].name === item.name
        ) {
          tempServices.splice(serviceLength, 1);
        }
      }
    }
  };

  const selectAllStdServices = () => {
    if (allSelected) showFooter(true);

    const originalServices = stdServices.map((item) => {
      const existingService = selectedStdServices?.find(
        (service) => service?.name === item?.label,
      );

      const isAddendum = contractAddendumDetails?.notActive;
      return {
        name: item.label,
        ...(isAddendum
          ? { contract_addendum: formData?.id }
          : { contract: formData?.id }),
        ...(existingService?.id ? { id: existingService.id } : {}),
      };
    });

    const tempServices = [...originalServices];

    let nextUpdatedFormData = { ...updatedFormData };

    if (
      updatedFormData?.standard_us_services?.delete?.length ===
      stdServices?.length
    ) {
      nextUpdatedFormData = {
        ...nextUpdatedFormData,
        standard_us_services: {
          ...nextUpdatedFormData.standard_us_services,
          delete: [],
        },
      };
    } else {
      removeServicesWithId(tempServices);

      if (tempServices?.length) {
        nextUpdatedFormData = {
          ...nextUpdatedFormData,
          standard_us_services: {
            ...nextUpdatedFormData.standard_us_services,
            create: [...tempServices],
            delete: [],
          },
        };
      }
    }

    setFormData({
      ...formData,
      standard_us_services: originalServices,
      selectAllStdServices,
    });

    setUpdatedFormData(nextUpdatedFormData);
    setAllSelected(true);
  };

  const handleChange = (event, selectedService) => {
    showFooter(true);
    let showServiceInTable = [];
    if (formData?.standard_us_services?.length)
      showServiceInTable = [...formData?.standard_us_services];

    if (!event.target.checked) {
      // add the selected service in the delete array and remove the service from the agreement table (on LHS).
      const tempService = updatedFormData?.standard_us_services?.delete?.find(
        (ele) => ele === selectedService?.id,
      );
      if (!tempService) {
        let tempDeletedServices = [];
        if (updatedFormData?.standard_us_services?.delete) {
          tempDeletedServices = [
            ...updatedFormData.standard_us_services?.delete,
          ];
        }
        showServiceInTable = formData?.standard_us_services?.filter(
          (op) => op.name !== event.target.name,
        );
        let createServices = updatedFormData?.standard_us_services?.create
          ?.length
          ? [...updatedFormData?.standard_us_services?.create]
          : [];
        createServices = updatedFormData?.standard_us_services?.create?.filter(
          (op) => op.name !== event.target.name,
        );

        setFormData({
          ...formData,
          standard_us_services: showServiceInTable,
        });
        setUpdatedFormData({
          ...updatedFormData,
          standard_us_services: {
            create: createServices,
            delete: [...tempDeletedServices, selectedService?.id],
          },
        });
      }
    }
    if (event.target.checked) {
      const isAddendum = contractAddendumDetails?.notActive;

      // Use utility function to prepare updatedFormData and service object
      const { nextUpdatedFormData, newServiceObject } =
        getUpdatedFormDataForAddService({
          serviceName: event.target.name,
          existingService: selectedService?.id ? selectedService : null,
          updatedFormData,
          formData,
          isAddendum,
        });

      showServiceInTable.push(newServiceObject);

      setFormData({
        ...formData,
        standard_us_services: showServiceInTable,
      });
      setUpdatedFormData(nextUpdatedFormData);
    }
  };

  const deSelectAllStdServices = () => {
    showFooter(true);
    const serviceIds = [];
    selectedStdServices.filter(({ id }) => {
      if (id) serviceIds.push(id);
      return null;
    });
    setAllSelected(false);
    $('.checkboxes-std-services input:checkbox').prop('checked', false);
    setFormData({
      ...formData,
      standard_us_services: [],
    });
    setUpdatedFormData({
      ...updatedFormData,
      standard_us_services: {
        delete: serviceIds,
      },
    });
  };

  useEffect(() => {
    if (
      formData?.standard_us_services?.length === stdServices?.length &&
      stdServices?.length > 0
    ) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  }, [formData?.standard_us_services, stdServices]);
  return (
    <div className="mb-4">
      <InputFormField className="mb-3">
        <label htmlFor="additional_one_time_services">Standard Services</label>
        <div
          className="add-discount"
          role="presentation"
          onClick={() =>
            allSelected ? deSelectAllStdServices() : selectAllStdServices()
          }
        >
          {allSelected ? 'Deselect All' : 'Select All'}
        </div>
      </InputFormField>
      {stdServices?.map((serviceData) => {
        const isChecked = !!formData?.standard_us_services?.find(
          (item) => item?.name === serviceData?.label,
        );
        return (
          <CheckBox key={serviceData?.value}>
            <label
              className="check-container checkboxes-std-services customer-pannel"
              htmlFor={serviceData?.value}
            >
              {serviceData?.label}
              <input
                type="checkbox"
                name={serviceData?.value}
                id={serviceData?.value}
                checked={isChecked}
                onChange={(event) =>
                  handleChange(
                    event,
                    selectedStdServices?.find(
                      (item) => item?.name === serviceData?.value,
                    ),
                  )
                }
              />
              <span className="checkmark" />
            </label>
          </CheckBox>
        );
      })}
    </div>
  );
}

StandardServices.defaultProps = {
  formData: {},
  stdServices: [],
  updatedFormData: {},
  setFormData: () => {},
  setUpdatedFormData: () => {},
  showFooter: () => {},
  contractAddendumDetails: {},
  addendumDetails: {},
  originalData: {},
};

StandardServices.propTypes = {
  formData: shape({
    standard_us_services: arrayOf(shape({})),
  }),
  stdServices: arrayOf(shape({})),
  updatedFormData: shape({}),
  setFormData: func,
  setUpdatedFormData: func,
  showFooter: func,
  contractAddendumDetails: shape({ notActive: bool }),
  addendumDetails: shape({}),
  originalData: shape({}),
};
